import { Button, Dialog, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import { AppModels, CompanyAttrs, brandNewCompany, companySlice, companyValidator, generateItemCode, hasErrors, saveModel } from 'cdx-common';
import React from 'react';
import { appStore } from '../../store';


export const AddCompany = (props: { onClose: () => void; }) => {

    const [company, setCompany] = React.useState<CompanyAttrs>(brandNewCompany);
    const [suggestCode, setSuggestCode] = React.useState('');

    React.useEffect(() => {
        setSuggestCode(generateItemCode(company.name));
    }, [company]);

    React.useEffect(() => {
        setCompany({ ...brandNewCompany });
    }, []);

    const update = (p: Partial<CompanyAttrs>) => {
        setCompany(q => {
            return { ...q, ...p };
        });
    };

    const onCreateClick = async () => {
        const validatedCompany = await companyValidator.validate(company);
        if (!hasErrors(validatedCompany)) {
            const newCompany = await saveModel(AppModels.companies, validatedCompany);
            if (!hasErrors(newCompany)) {
                appStore.dispatch(companySlice.actions.addOne(newCompany));
                props.onClose();
            } else {
                setCompany(newCompany);
            }
        } else {
            setCompany(validatedCompany);
        }
    };

    return <Dialog open={true} onClose={props.onClose}>
        <DialogContent>
            <DialogTitle>Nouvelle compagnie</DialogTitle>
            <Grid container spacing={2} columns={2}>
                <Grid item xs={2}>
                    <TextField
                        fullWidth
                        label='Nom'
                        value={company.name}
                        error={!!company.__errors?.name}
                        helperText={company.__errors?.name}
                        onChange={(event) => update({ name: event.target.value })} />
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        fullWidth
                        label='Code'
                        placeholder={suggestCode}
                        value={company.code}
                        error={!!company.__errors?.code}
                        helperText={company.__errors?.code}
                        onChange={(event) => update({ code: event.target.value })} />
                </Grid>
                <Grid item xs={1} alignContent='center'>
                    <Button color='primary' onClick={onCreateClick}>Créer</Button>
                    <Button color='secondary' onClick={props.onClose}>Annuler</Button>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog>;
}; 
